import {KeyboardArrowDown,KeyboardArrowUp ,UnfoldMore} from '@mui/icons-material'
import './sortwidget.scss'

import React ,{useEffect, useState}from 'react'
interface iProps {item:string,index:number
  ,sort:{selectedIndex:number,trigger:boolean ,up:boolean,down:boolean}
  ,show:number | undefined}
export default function SortWidget({item,index,sort,show}:iProps) {
    
    //  useEffect(()=>{
    // if (sort.selectedIndex === index) {
    //     setSort((pre:any)=>({...pre,up:!pre.up,down:!pre.down}))
    // }
    //  },[sort.trigger])

  return (
   
   
    <>
    {(show && 
    Boolean(item)) ?
      <div className='sort_container'>
     
        {
            sort.selectedIndex !== index?
            <UnfoldMore />
            :
            sort.up?<KeyboardArrowUp />:
            <KeyboardArrowDown />
        }
           {item}
    </div>:
    item
    }
    </>

  )
}
